import React, { useState } from 'react';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { obtenerNombreEmpresaReal } from '../../../config/unificacion';
import { useCorreosMarketingModel } from '../../../modelos/EmailMarkeeting/modeloCorreos';

const CreadorPlantillas = () => {
  // 1. CONFIGURACIÓN Y CONTEXTO DE EMPRESA MANTENIDO
  const { configuracion } = useConfiguracion();
  const nombreEmpresa = obtenerNombreEmpresaReal(configuracion.nombreEmpresa);

  // Cargar modelo de marketing
  const { createPlantilla } = useCorreosMarketingModel();

  // 2. ESTADOS DE CONTROL (Añadido: descripcion)
  const [nombrePlantilla, setNombrePlantilla] = useState('');
  const [descripcion, setDescripcion] = useState(''); // 🌟 NUEVO ESTADO
  const [asunto, setAsunto] = useState('¡Tenemos una actualización importante para ti!');
  const [guardando, setGuardando] = useState(false);
  
  // El corazón del editor
  const [bloques, setBloques] = useState([
    { id: '1', tipo: 'titulo', value: 'Verifica tu correo' },
    { id: '2', tipo: 'texto', value: 'Hola **{{nombre}}**, usa el siguiente código para completar tu registro:' },
    { id: '3', tipo: 'texto', value: '**1 2 3 4 5 6**' },
    { id: '4', tipo: 'boton', value: 'Confirmar Registro', url: 'https://', color: '#1e3a8a' }
  ]);

  const variablesDisponibles = [
    { tag: '{{nombre}}', desc: 'Nombre del usuario' },
    { tag: '{{universidad}}', desc: 'Universidad detectada' },
    { tag: '{{carrera}}', desc: 'Carrera del registro' }
  ];

  // Helper para renderizar texto enriquecido con negrillas en la Vista Previa de React
  const formatearTextoPreview = (texto) => {
    if (!texto) return '';
    const partes = texto.split(/\*\*([\s\S]*?)\*\*/g);
    return partes.map((parte, i) => i % 2 === 1 ? <strong key={i} className="font-bold text-gray-900">{parte}</strong> : parte);
  };

  // 3. FUNCIONES PARA MANIPULAR BLOQUES
  const agregarBloque = (tipo) => {
    const moldes = {
      titulo: { id: Date.now().toString(), tipo: 'titulo', value: 'Nuevo Título Destacado' },
      texto: { id: Date.now().toString(), tipo: 'texto', value: 'Escribe tu texto aquí. Usa **negrilla** para resaltar.' },
      imagen: { id: Date.now().toString(), tipo: 'imagen', value: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800' },
      boton: { id: Date.now().toString(), tipo: 'boton', value: 'Botón de Acción', url: 'https://', color: '#1e3a8a' },
      separador: { id: Date.now().toString(), tipo: 'separador' }
    };
    setBloques([...bloques, moldes[tipo]]);
  };

  const eliminarBloque = (id) => {
    setBloques(bloques.filter(b => b.id !== id));
  };

  const actualizarBloque = (id, campo, valor) => {
    setBloques(bloques.map(b => b.id === id ? { ...b, [campo]: valor } : b));
  };

  const moverBloque = (index, direccion) => {
    const nuevosBloques = [...bloques];
    const destino = direccion === 'arriba' ? index - 1 : index + 1;
    if (destino < 0 || destino >= bloques.length) return;
    const [removido] = nuevosBloques.splice(index, 1);
    nuevosBloques.splice(destino, 0, removido);
    setBloques(nuevosBloques);
  };

  // 4. COMPILADOR MULTI-BLOQUE A HTML
  const generarHtmlFinal = () => {
    let filasHtml = '';

    bloques.forEach(b => {
      const procesarNegrillasHtml = (txt) => txt.replace(/\*\*([\s\S]*?)\*\*/g, '<strong style="font-weight: bold; color: #111827;">$1</strong>');

      if (b.tipo === 'titulo' && b.value) {
        filasHtml += `
          <tr>
            <td align="center" style="padding-bottom: 20px; font-family: sans-serif;">
              <h1 style="color: #1e3a8a; font-size: 24px; font-weight: bold; margin: 0; padding: 0;">${b.value}</h1>
            </td>
          </tr>`;
      } else if (b.tipo === 'texto' && b.value) {
        filasHtml += `
          <tr>
            <td align="center" style="padding-bottom: 25px; font-family: sans-serif; font-size: 15px; line-height: 1.6; color: #4b5563; white-space: pre-line;">
              ${procesarNegrillasHtml(b.value)}
            </td>
          </tr>`;
      } else if (b.tipo === 'imagen' && b.value) {
        filasHtml += `
          <tr>
            <td style="padding-bottom: 20px; text-align: center;">
              <img src="${b.value}" alt="Imagen" width="540" style="width: 100%; max-width: 540px; height: auto; border-radius: 8px; display: block; margin: 0 auto;" />
            </td>
          </tr>`;
      } else if (b.tipo === 'boton' && b.value) {
        filasHtml += `
          <tr>
            <td align="center" style="padding-bottom: 25px;">
              <table border="0" cellpadding="0" cellspacing="0">
                <tr>
                  <td align="center" style="border-radius: 6px;" bgcolor="${b.color}">
                    <a href="${b.url}" target="_blank" style="font-size: 15px; font-family: sans-serif; font-weight: bold; color: #ffffff; text-decoration: none; padding: 12px 30px; display: inline-block; border-radius: 6px;">
                      ${b.value}
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>`;
      } else if (b.tipo === 'separador') {
        filasHtml += `
          <tr>
            <td style="padding: 15px 0 25px 0;">
              <hr style="border: 0; border-top: 1px solid #e5e7eb;" />
            </td>
          </tr>`;
      }
    });

    return `
      <div style="background-color: #f3f4f6; padding: 30px; font-family: sans-serif;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" width="600" style="background-color: #ffffff; border-radius: 12px; border-top: 5px solid #1e3a8a; padding: 40px 30px; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
          ${filasHtml}
        </table>
        {{tracking_pixel}}
      </div>
    `;
  };

  // 5. ACCIÓN: PERSISTENCIA EN POSTGRESQL (Modificado payload)
  const handleGuardar = async () => {
    if (!nombrePlantilla.trim()) return alert("⚠️ Asigna un nombre interno a la plantilla.");
    if (bloques.length === 0) return alert("⚠️ No puedes guardar una plantilla vacía.");
    
    setGuardando(true);

    const data = {
      empresa_nombre: nombreEmpresa,
      nombre: nombrePlantilla,
      descripcion: descripcion.trim(), // 🌟 CAPTURAMOS LA DESCRIPCIÓN PARA POSTGRES
      contenido_json: { asunto, bloques }, 
      contenido_html: generarHtmlFinal()
    };

    try {
      const exito = await createPlantilla(data);
      
      if (exito) {
        setNombrePlantilla('');
        setDescripcion(''); // 🌟 LIMPIAMOS LA DESCRIPCIÓN TRAS GUARDAR
      }
    } catch (error) {
      console.error("Flujo detenido en vista por error controlado.");
    } finally { 
      setGuardando(false); 
    }
  };

  return (
    <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 text-sm animate-fadeIn text-left">
      
      {/* COLUMNA CONTROLES E INPUTS DINÁMICOS */}
      <div className="xl:col-span-7 space-y-4">
        
        <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 space-y-3">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b pb-2 gap-2">
            <div>
              <h3 className="text-base font-bold text-gray-900">Configuración Base</h3>
              <p className="text-[11px] text-gray-400">Tip: Enmarca palabras con doble asterisco para hacerlas **negrilla**.</p>
            </div>
            
            <div className="flex flex-wrap gap-1 bg-slate-100 p-1 rounded-md border text-[11px]">
              <button type="button" onClick={() => agregarBloque('titulo')} className="bg-white hover:bg-slate-50 px-2 py-1 rounded font-medium shadow-sm text-blue-700 font-bold">#️ Título</button>
              <button type="button" onClick={() => agregarBloque('texto')} className="bg-white hover:bg-slate-50 px-2 py-1 rounded font-medium shadow-sm">📝 Texto</button>
              <button type="button" onClick={() => agregarBloque('imagen')} className="bg-white hover:bg-slate-50 px-2 py-1 rounded font-medium shadow-sm">🖼️ Imagen</button>
              <button type="button" onClick={() => agregarBloque('boton')} className="bg-white hover:bg-slate-50 px-2 py-1 rounded font-medium shadow-sm">🖱️ Botón</button>
              <button type="button" onClick={() => agregarBloque('separador')} className="bg-white hover:bg-slate-50 px-2 py-1 rounded font-medium shadow-sm">➖ Línea</button>
            </div>
          </div>

          {/* CUADRICULA DE DATOS MAESTROS DE LA PLANTILLA */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Nombre Plantilla (Interno)</label>
              <input type="text" value={nombrePlantilla} onChange={(e) => setNombrePlantilla(e.target.value)} placeholder="Ej: Verificación de Cuenta V1" className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-xs outline-none focus:ring-1 focus:ring-blue-500" />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-600 mb-1">Asunto por defecto</label>
              <input type="text" value={asunto} onChange={(e) => setAsunto(e.target.value)} className="w-full px-3 py-1.5 border rounded-md text-xs outline-none focus:ring-1 focus:ring-blue-500" />
            </div>
            {/* 🌟 NUEVO CAMPO: INPUT PARA LA DESCRIPCIÓN */}
            <div className="md:col-span-2">
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Descripción de la Plantilla</label>
              <input 
                type="text" 
                value={descripcion} 
                onChange={(e) => setDescripcion(e.target.value)} 
                placeholder="Ej: Código de verificación enviado al registrarse un nuevo tutor o cliente" 
                className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-xs outline-none focus:ring-1 focus:ring-blue-500" 
              />
            </div>
          </div>
        </div>

        {/* CONTENEDOR DE BLOQUES */}
        <div className="space-y-3 overflow-y-auto max-h-[400px] pr-1">
          {bloques.map((b, index) => (
            <div key={b.id} className="p-4 bg-white rounded-xl border border-gray-200 shadow-sm relative group/block transition-all hover:border-gray-300">
              
              <div className="flex justify-between items-center mb-2 bg-slate-50 p-1.5 rounded-lg border">
                <span className="text-[10px] font-black uppercase text-slate-500 tracking-wider">
                  Elemento {index + 1}: <span className="text-blue-600 font-bold">{b.tipo}</span>
                </span>
                <div className="flex items-center space-x-2">
                  <button type="button" onClick={() => moverBloque(index, 'arriba')} disabled={index === 0} className="text-gray-400 hover:text-gray-700 disabled:opacity-20 font-bold text-xs">▲</button>
                  <button type="button" onClick={() => moverBloque(index, 'abajo')} disabled={index === bloques.length - 1} className="text-gray-400 hover:text-gray-700 disabled:opacity-20 font-bold text-xs">▼</button>
                  <span className="text-gray-300">|</span>
                  <button type="button" onClick={() => eliminarBloque(b.id)} className="text-red-500 hover:text-red-700 text-xs font-bold">Eliminar</button>
                </div>
              </div>

              {b.tipo === 'titulo' && (
                <input type="text" value={b.value} onChange={(e) => actualizarBloque(b.id, 'value', e.target.value)} placeholder="Introduce el encabezado del correo..." className="w-full p-2 border rounded-md text-xs font-bold text-gray-900 outline-none focus:ring-1 focus:ring-blue-500" />
              )}

              {b.tipo === 'texto' && (
                <textarea value={b.value} rows="3" onChange={(e) => actualizarBloque(b.id, 'value', e.target.value)} className="w-full p-2 border rounded-md text-xs outline-none focus:ring-1 focus:ring-blue-500 resize-none" />
              )}

              {b.tipo === 'imagen' && (
                <input type="text" value={b.value} onChange={(e) => actualizarBloque(b.id, 'value', e.target.value)} placeholder="Introduce la URL absoluta de tu imagen (HTTPS)" className="w-full p-2 border rounded-md text-xs outline-none" />
              )}

              {b.tipo === 'boton' && (
                <div className="space-y-2">
                  <input type="text" value={b.value} onChange={(e) => actualizarBloque(b.id, 'value', e.target.value)} placeholder="Texto del botón" className="w-full p-1.5 border rounded-md text-xs" />
                  <div className="grid grid-cols-2 gap-2">
                    <input type="text" value={b.url} onChange={(e) => actualizarBloque(b.id, 'url', e.target.value)} placeholder="Enlace URL (ej: https://wa.me/...)" className="p-1.5 border rounded-md text-xs" />
                    <select value={b.color} onChange={(e) => actualizarBloque(b.id, 'color', e.target.value)} className="p-1.5 border rounded-md text-xs bg-white outline-none">
                      <option value="#1e3a8a">Azul Marino (Dufy)</option>
                      <option value="#dc2626">Rojo Promoción</option>
                      <option value="#059669">Verde WhatsApp</option>
                      <option value="#374151">Gris Oscuro</option>
                    </select>
                  </div>
                </div>
              )}

              {b.tipo === 'separador' && (
                <div className="py-2 text-center text-xs text-gray-400 border border-dashed rounded-md bg-gray-50 font-mono">Línea divisoria estética</div>
              )}

            </div>
          ))}
        </div>

      </div>

      {/* COLUMNA PREVIEW EN VIVO Y DICCIONARIO */}
      <div className="xl:col-span-5 flex flex-col justify-between space-y-4">
        
        <div className="bg-slate-50 p-4 rounded-xl border border-gray-200 flex flex-col items-center flex-1 min-h-[400px]">
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block mb-3 text-left w-full">Vista Previa del Mensaje</span>
          
          <div className="bg-white rounded-xl shadow-md border-t-4 border-blue-900 text-gray-700 w-full p-5 max-w-[340px] overflow-y-auto max-h-[440px]">
            <div className="space-y-4">
              {bloques.map(b => (
                <div key={b.id} className="text-center">
                  {b.tipo === 'titulo' && <h2 className="text-base font-black text-blue-900 tracking-tight">{b.value}</h2>}
                  {b.tipo === 'imagen' && b.value && <img src={b.value} alt="Preview" className="w-full rounded-lg object-cover max-h-36 mx-auto" onError={(e) => e.target.style.display='none'} />}
                  {b.tipo === 'texto' && <p className="text-gray-600 text-xs whitespace-pre-line leading-relaxed">{formatearTextoPreview(b.value)}</p>}
                  {b.tipo === 'boton' && (
                    <div className="py-1">
                      <span style={{ backgroundColor: b.color }} className="text-white font-bold text-[11px] px-5 py-2 rounded-md inline-block shadow-sm select-none">
                        {b.value}
                      </span>
                    </div>
                  )}
                  {b.tipo === 'separador' && <hr className="border-gray-200 my-1" />}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* PANEL COPIADOR DE VARIABLES */}
        <div className="bg-slate-900 text-white p-4 rounded-xl shadow-md space-y-2">
          <h4 className="text-xs font-bold text-emerald-400">📋 Marcadores Dinámicos</h4>
          <div className="space-y-1">
            {variablesDisponibles.map(v => (
              <div key={v.tag} onClick={() => { navigator.clipboard.writeText(v.tag); alert(`Copiado: ${v.tag}`); }} className="flex justify-between p-1.5 rounded bg-white/5 hover:bg-white/10 cursor-pointer text-[11px]">
                <code className="text-emerald-300 font-mono font-bold">{v.tag}</code>
                <span className="text-gray-400 truncate max-w-[140px] text-right">{v.desc}</span>
              </div>
            ))}
          </div>
        </div>

        {/* GUARDADO EN POSTGRES */}
        <button 
          onClick={handleGuardar} 
          disabled={guardando || !nombrePlantilla} 
          className={`w-full py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-xs font-bold shadow-md transition-all ${guardando || !nombrePlantilla ? 'opacity-40 cursor-not-allowed' : ''}`}
        >
          {guardando ? 'Guardando Estructura...' : '💾 Guardar Plantilla de Correo'}
        </button>

      </div>

    </div>
  );
};

export default CreadorPlantillas;